import { CertificateType } from '../../../pages/ClientPanel/Certificates/CreateCertificate'

function firstStockMaterial(service: any): {
  startingMaterial: string
  heatNumber: CertificateType['heatNumber']
  description: string
} | null {
  for (const row of service?.StockInProduction ?? []) {
    if (row?.stockId == null || !row.Stock) continue
    const stock = row.Stock
    const code = stock.Code?.code?.trim() || ''
    const startingMaterial =
      code || stock.description || String(stock.id ?? '')
    if (!startingMaterial) continue

    const hn = stock.HeatNumber
    return {
      startingMaterial,
      description: stock.description,
      heatNumber: hn
        ? {
            id: hn.id,
            heatNumber: hn.heatNumber ?? '',
            originCertificateId: hn.Certificate?.[0]?.id,
          }
        : { id: 0, heatNumber: '', originCertificateId: undefined },
    }
  }
  return null
}

export function mergeCertificateWithServiceDetail(
  prev: CertificateType,
  service: any,
): CertificateType {
  const material = firstStockMaterial(service)
  return {
    ...prev,
    serviceId: service.id,
    codeOpString: service.codeOfOP ?? '',
    purchaseOrderNumber: service.OrderItem?.Order?.npc ?? '',
    ...(material
      ? { startingMaterial: material.startingMaterial, heatNumber: material.heatNumber, description: material.description }
      : {}),
  }
}
